module.exports = __webpack_public_path__ + "static/media/file-excel.6ac2d7d1.svg";